var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar bg-neutral text-neutral-content"},[_c('router-link',{staticClass:"btn btn-ghost normal-case text-xl",attrs:{"to":"/"}},[_vm._v("expat.com")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }